import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import block from 'bem-cn';
import { useSelector } from 'react-redux';
import { rankTypes } from 'features/ranking/data';

import bannerBronzeWEBP from './img/bronze.webp';
import bannerSilverWEBP from './img/Plata.webp';
import bannerProveedoresSilverWEBP from './img/silver.webp';
import bannerProveedoresGoldWEBP from './img/gold.webp';

import './Banner.scss';

const b = block('app-banner');

const Banner = () => {
  const location = useLocation();
  const { withRanking, myRank } = useSelector(state => state.rankings);
  const isBannerShown = useMemo(() => {
    return (
      ['/users/all'].includes(location.pathname) &&
      withRanking &&
      (myRank?.rank === rankTypes.silver ||
        myRank?.rank === rankTypes.bronze ||
        myRank?.rank === rankTypes.providerSilver ||
        myRank?.rank === rankTypes.providerGold)
    );
  }, [location.pathname, withRanking, myRank?.rank]);

  if (isBannerShown) {
    return (
      <Link to="/ranking" className={b()}>
        {myRank?.rank === rankTypes.silver ? (
          <img src={bannerSilverWEBP} alt="Silver banner" />
        ) : myRank?.rank === rankTypes.bronze ? (
          <img src={bannerBronzeWEBP} alt="Cashier banner" />
        ) : myRank?.rank === rankTypes.providerGold ? (
          <img src={bannerProveedoresGoldWEBP} alt="Proveedores Gold banner" />
        ) : (
          <img src={bannerProveedoresSilverWEBP} alt="Proveedores Silver banner" />
        )}
      </Link>
    );
  }

  return null;
};

export default Banner;
